import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { getWallet, getTransactionHistory } from "../../services/auth/User";
import Loader2 from "../../components/Loader2";
import "./profile.css";

function Wallet() {
  const [isPending, setIsPending] = useState(true);
  const [balance, setBalance] = useState(0);
  const [showAddress, setShowAddress] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [totalTransactions, setTotalTransactions] = useState(0);
  const [page, setPage] = useState(0);
  const LIMIT = 10;

  const handleComingSoon = () => {
    const address = "0x53432aFF4b2d97f0bd4fBa288d833ba86e17b381";
    navigator.clipboard.writeText(address).then(() => {
      toast.success("Receiving address copied");
      setShowAddress(true);
    });
  };

  useEffect(() => {
    fetchWalletData();
  }, []);

  useEffect(() => {
    fetchTransactions();
  }, [page]);

  const fetchWalletData = async () => {
    try {
      setIsPending(true);
      const response = await getWallet();
      setBalance(response?.wallet?.balance ?? 0);
    } catch (error) {
      console.error("Failed to fetch wallet:", error);
    } finally {
      setIsPending(false);
    }
  };

  const fetchTransactions = async () => {
    try {
      const response = await getTransactionHistory(LIMIT, page * LIMIT);
      if (response?.success) {
        setTransactions(response.transactions || []);
        setTotalTransactions(response.pagination?.total || 0);
      }
    } catch (error) {
      console.error("Failed to fetch transactions:", error);
    }
  };

  const totalPages = Math.ceil(totalTransactions / LIMIT);

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <>
      {isPending && <Loader2 />}
      <div className="contain">
        <h1>Wallet</h1>

        <div className="boxy">
          <div className="tab-top">
            <h3>Wallet</h3>
          </div>
          <div className="seperator"></div>
          <div className="tab-body">
            <div className="wallet">
              <div className="wallet-item">
                <h3>Wallet Balance</h3>
                <div className="wallet-balance">
                  <h3>
                    {balance} <span>CGT Bonus</span>
                  </h3>
                  <h3>
                    = {balance} <span>INR</span>
                  </h3>
                  <button
                    type="button"
                    className="btn-1"
                    onClick={handleComingSoon}
                  >
                    Add CGT
                  </button>
                  <br />
                  {showAddress && (
                    <h3>
                      Receiving address: 0x53432aFF4b2d97f0bd4fBa288d833ba86e17b381
                    </h3>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Transaction History */}
        <div className="boxy" style={{ marginTop: "20px" }}>
          <div className="tab-top">
            <h3>Transaction History</h3>
          </div>
          <div className="seperator"></div>
          <div className="tab-body">
            {transactions.length === 0 ? (
              <p style={{ fontFamily: "var(--font2)", color: "#888", fontSize: "0.9rem" }}>
                No transactions yet.
              </p>
            ) : (
              <>
                <div style={{ overflowX: "auto" }}>
                  <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "var(--font2)", fontSize: "0.85rem" }}>
                    <thead>
                      <tr style={{ backgroundColor: "#f5f5f5", textAlign: "left" }}>
                        <th style={{ padding: "10px 12px", borderBottom: "1px solid #e0e0e0", whiteSpace: "nowrap" }}>Date</th>
                        <th style={{ padding: "10px 12px", borderBottom: "1px solid #e0e0e0", whiteSpace: "nowrap" }}>Remark</th>
                        <th style={{ padding: "10px 12px", borderBottom: "1px solid #e0e0e0", whiteSpace: "nowrap" }}>Credited</th>
                        <th style={{ padding: "10px 12px", borderBottom: "1px solid #e0e0e0", whiteSpace: "nowrap" }}>Debited</th>
                        <th style={{ padding: "10px 12px", borderBottom: "1px solid #e0e0e0", whiteSpace: "nowrap" }}>Status</th>
                        <th style={{ padding: "10px 12px", borderBottom: "1px solid #e0e0e0", whiteSpace: "nowrap" }}>Source</th>
                      </tr>
                    </thead>
                    <tbody>
                      {transactions.map((txn, index) => (
                        <tr key={txn._id || index} style={{ borderBottom: "1px solid #f0f0f0" }}>
                          <td style={{ padding: "10px 12px", whiteSpace: "nowrap" }}>{formatDate(txn.date)}</td>
                          <td style={{ padding: "10px 12px" }}>{txn.transactionRemark || "-"}</td>
                          <td style={{ padding: "10px 12px", color: txn.creditedAmount > 0 ? "#2e7d32" : "#888", fontWeight: txn.creditedAmount > 0 ? "600" : "400" }}>
                            {txn.creditedAmount > 0 ? `+${txn.creditedAmount}` : "-"}
                          </td>
                          <td style={{ padding: "10px 12px", color: txn.debitedAmount > 0 ? "#c62828" : "#888", fontWeight: txn.debitedAmount > 0 ? "600" : "400" }}>
                            {txn.debitedAmount > 0 ? `-${txn.debitedAmount}` : "-"}
                          </td>
                          <td style={{ padding: "10px 12px" }}>
                            <span style={{
                              padding: "3px 8px",
                              borderRadius: "4px",
                              fontSize: "0.8rem",
                              fontWeight: "500",
                              backgroundColor: txn.status === "Success" ? "#e8f5e9" : txn.status === "Pending" ? "#fff3e0" : "#ffebee",
                              color: txn.status === "Success" ? "#2e7d32" : txn.status === "Pending" ? "#e65100" : "#c62828",
                            }}>
                              {txn.status}
                            </span>
                          </td>
                          <td style={{ padding: "10px 12px" }}>{txn.source || "-"}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "10px", marginTop: "16px", fontFamily: "var(--font2)", fontSize: "0.85rem" }}>
                    <button
                      onClick={() => setPage((p) => Math.max(0, p - 1))}
                      disabled={page === 0}
                      style={{
                        padding: "6px 14px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        backgroundColor: page === 0 ? "#f5f5f5" : "white",
                        cursor: page === 0 ? "default" : "pointer",
                        color: page === 0 ? "#bbb" : "#333",
                      }}
                    >
                      Prev
                    </button>
                    <span>
                      Page {page + 1} of {totalPages}
                    </span>
                    <button
                      onClick={() => setPage((p) => Math.min(totalPages - 1, p + 1))}
                      disabled={page >= totalPages - 1}
                      style={{
                        padding: "6px 14px",
                        border: "1px solid #e0e0e0",
                        borderRadius: "4px",
                        backgroundColor: page >= totalPages - 1 ? "#f5f5f5" : "white",
                        cursor: page >= totalPages - 1 ? "default" : "pointer",
                        color: page >= totalPages - 1 ? "#bbb" : "#333",
                      }}
                    >
                      Next
                    </button>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Wallet;